// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__197O9","modalContent":"style_modalContent__kg5Q-","modalBtn":"style_modalBtn__1bKH7"};